import script from "./recommend-list.vue?vue&type=script&setup=true&lang=js"
export * from "./recommend-list.vue?vue&type=script&setup=true&lang=js"

import "./recommend-list.vue?vue&type=style&index=0&id=540eb2b9&scoped=true&lang=scss"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540eb2b9"]])

export default __exports__